<agm-marker
  *ngIf="feeder"
  [latitude]="lat"
  [longitude]="lng"
  [iconUrl]="iconsValidators(feeder)"
  (markerClick)="markerClick()"
  [markerDraggable]="draggable"
  [label]="type === 'feeder_ordering' || type === 'waterwise_ordering' ? { color: 'white', text: feeder?.name } : null"
  (dragEnd)="draggable && dragEndMarker($event)"
>
  <ng-container *ngIf="(view && type === 'feeder' || type === 'feeder_sweep') && storageService.validateSoloAdmin()">
    <agm-info-window>
      <div class="text-center">
        {{ feeder.name }} <br /><br />

        <div *ngIf="feeder.warranty_start_date; else nullWarranty">
          <p>
            {{ "marker.warranty-implementation-date" | translate }}: {{ feeder ? (feeder.warranty_start_date | date :
            "yyyy-MM-dd HH:mm") : "" }}
          </p>
          <p>{{ "marker.warranty-months" | translate }}: {{ feeder.warranty_months ? feeder.warranty_months : "" }}</p>
          <p>
            {{ "marker.warranty-days-remaining" | translate }}: {{ feeder.warranty_days_remaining ?
            feeder.warranty_days_remaining : "" }}
          </p>
        </div>
        <ng-template #nullWarranty>
          <p>{{ "waterwises.no-warranty-date" | translate }}</p>
        </ng-template>
        <button
          *ngIf="type === 'feeder'"
          class="btn btn-secondary"
          (click)="setValueFeederTest(feeder)"
        >
          {{ "alerts.general.test" | translate }}
        </button>
      </div>
    </agm-info-window>
  </ng-container>
  <ng-container *ngIf="view && type === 'sensors'">
    <agm-info-window>
      <div class="d-flex justify-content-between my-1">
        {{ "clients.sensors.title" | translate }}
        <i
          class="fa ml-2"
          [class]="
              validateNormalSensors(feeder)
                ? 'fa-check-circle text-success'
                : 'fa-circle text-gray'
            "
        ></i>
      </div>
      <!--   <div class="d-flex justify-content-between my-1">
        Sensores Hydro
        <i
          class="fa ml-2"
          [class]="
              validateHydroSensors(feeder)
                ? 'fa-check-circle text-success'
                : 'fa-circle text-gray'
            "
        ></i>
      </div> -->
      <div class="center w-100 text-white">
        <button class="mt-2 btn btn-primary" (click)="onClickButtonActionSensor()">
          {{ "marker.view-zone" | translate }} <i class="fas fa-external-link-alt ml-1"></i>
        </button>
      </div>
    </agm-info-window>
  </ng-container>
  <ng-container *ngIf="view && type === 'gateway' && feeder">
    <agm-marker
      *ngIf="feeder.gateway && feeder.gateway.installation"
      [latitude]="feeder.gateway.installation.lat"
      [longitude]="feeder.gateway.installation.lng"
      [opacity]="1"
      [markerDraggable]="false"
      [iconUrl]="antenaURL"
    >
      <agm-info-window>
        <h5>{{ feeder.gateway.name }}</h5>
      </agm-info-window>
    </agm-marker>
  </ng-container>
  <ng-container *ngIf="view && type === 'feeders_gateway' && feeder">
    <agm-marker
      [latitude]="feeder.lat"
      [longitude]="feeder.lng"
      [markerDraggable]="false"
      [iconUrl]="feeder.markerTemplate"
    >
      <agm-info-window>
        <h5>{{ feeder.name }}</h5>
        {{'admin.clients.network.decibels' | translate}}: {{ feeder.status_db ? ("-" +
        feeder.status_db + "/-40") : ('admin.clients.network.no-decibels' | translate) }}
      </agm-info-window>
    </agm-marker>
  </ng-container>
</agm-marker>
